export enum ExportType {
  FILE = 'file',
  ARCHIVE = 'archive',
}
